export { default, Icon } from '../components/icon-new';